export default __webpack_public_path__ + "static/media/BlackPlus.2d261b4f.svg";